<h3 class="title">
  <span class="basic-flex-container">
    HTML file
    @if (!templateValid) {
      <mat-icon
        class="error-circle"
        fontIcon="error_outline"
        [matTooltip]="'Please ensure you have a valid template file.'"
        matTooltipShowDelay="500"
      ></mat-icon>
    }
  </span>
  @if (!formGroup.get('sourceValue')?.value) {
    <mat-slide-toggle
      [(ngModel)]="showDependencies"
      [matTooltip]="'Specify any dependencies needed'"
      [matTooltipShowDelay]="500"
      >
      View dependencies
    </mat-slide-toggle>
  }
</h3>
<app-upload-file
  [formGroup]="formGroup"
  [workflowConfigId]="workflowConfigId"
  [acceptableFileTypes]="['.html', '.htm']"
  [getFileInfo]="getInfo.bind(this)"
  [fileValid]="templateValid"
  >
</app-upload-file>

@if (showDependencies || formGroup.get('sourceValue')?.value) {
  <div id="dependency-chips" @transitionHeight>
    <h3>Dependencies</h3>
    <app-chips
      [placeholder]="'Enter field path...'"
      [tooltip]="'The path to the required dependency.'"
      [chips]="getDependencies()"
      (addChipEmitter)="addDependency($event)"
      (removeChipEmitter)="removeDependency($event)"
      >
    </app-chips>
  </div>
}

<!--{{formGroup.value | json}} {{formGroup.valid}}-->
